import "./App.css";
import * as THREE from "three";
import React, { useRef, Suspense, useEffect, useState } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import {
  Reflector,
  Html,
  useTexture,
  useGLTF,
  useProgress,
  useCursor,
  useAnimations,
  Text,
} from "@react-three/drei";
import { a, useTransition } from "@react-spring/web";

function Carla(props) {
  const { scene, animations } = useGLTF("/scene.gltf");
  const [hovered, setActive] = useState(false);
  const [index, setIndex] = useState(4);
  console.log(animations);
  const { ref, actions, names } = useAnimations(animations);
  useEffect(() => {
    // Reset and fade in animation after an index has been changed
    actions[names[index]].reset().fadeIn(0.5).play();
    // In the clean-up phase, fade it out
    return () => actions[names[index]].fadeOut(0.5);
  }, [index, actions, names]);

  useCursor(hovered);
  return (
    <primitive
      onClick={() => setIndex((index + 1) % names.length)}
      ref={ref}
      onPointerOver={() => setActive(true)}
      onPointerOut={() => setActive(false)}
      object={scene}
      {...props}
    />
  );
}

function Ground() {
  const [floor, normal] = useTexture([
    "/SurfaceImperfections003_1K_var1.jpg",
    "/SurfaceImperfections003_1K_Normal.jpg",
  ]);
  return (
    <Reflector
      resolution={512}
      args={[10, 10]}
      mirror={0.4}
      mixBlur={8}
      mixStrength={1}
      rotation={[-Math.PI / 2, 0, Math.PI / 2]}
      blur={[400, 100]}
    >
      {(Material, props) => (
        <Material
          color="#a0a0a0"
          metalness={0.4}
          roughnessMap={floor}
          normalMap={normal}
          normalScale={[1, 1]}
          {...props}
        />
      )}
    </Reflector>
  );
}

function VideoText({ ready, clicked, ...props }) {
  const mesh = useRef();
  const [video] = useState(() =>
    Object.assign(document.createElement("video"), {
      src: "/drei.mp4",
      crossOrigin: "Anonymous",
      loop: true,
    })
  );
  //function that creates random color values
  const randomColor = () => {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  useEffect(() => void (clicked && video.play()), [video, clicked]);
  return (
    <>
      <mesh {...props} ref={mesh}>
        <boxGeometry args={[3, 3, 0.1]} />
        <meshBasicMaterial toneMapped={false}>
          {ready && clicked === true ? (
            <Html
              className="content"
              position={[0, 0.4, -1.499]}
              transform
              occlude
              scale={[0.08, 0.08, 0.05]}
            >
              <div
                id="carouselExampleIndicators"
                class="carousel slide"
                data-ride="carousel"
                style={{ width: "100%", height: "100%" }}
              >
                <ol class="carousel-indicators">
                  <li
                    data-target="#carouselExampleIndicators"
                    data-slide-to="0"
                    class="active"
                  ></li>
                  <li
                    data-target="#carouselExampleIndicators"
                    data-slide-to="1"
                  ></li>
                  <li
                    data-target="#carouselExampleIndicators"
                    data-slide-to="2"
                  ></li>
                  <li
                    data-target="#carouselExampleIndicators"
                    data-slide-to="3"
                  ></li>
                </ol>
                <div class="carousel-inner">
                  <div class="carousel-item active">
                    <a href="https://play.google.com/store/apps/details?id=com.jacobs.myapplication35">
                      <img
                        style={{ width: "1200px", height: "1200px" }}
                        src="/01.jpg"
                        alt="First slide"
                      />
                    </a>

                    <div class="carousel-caption d-none d-md-block">
                      <h5
                        style={{
                          color: "white",
                          fontSize: "4rem",
                          fontWeight: "bold",
                        }}
                      >
                        Rhyme App:
                        <br></br>
                        Android Studio, SQL{" "}
                      </h5>
                    </div>
                  </div>
                  <div class="carousel-item">
                    <a href="https://fashioned.herokuapp.com/">
                      <img
                        style={{ width: "1200px", height: "1200px" }}
                        src="/02.png"
                        alt="Second slide"
                      />
                    </a>

                    <div class="carousel-caption d-none d-md-block">
                      <h5
                        style={{
                          color: "#500c77",
                          fontSize: "4rem",
                          fontWeight: "bold",
                        }}
                      >
                        Fashion E-commerce
                        <br></br>
                        React, Node, MongoDB
                      </h5>
                    </div>
                  </div>
                  <div class="carousel-item" style={{ cursor: "zoom-in" }}>
                    <img
                      style={{ width: "1200px", height: "1200px" }}
                      src="03.jpg"
                      alt="Third slide"
                      cursor="pointer"
                    />
                    <div class="carousel-caption d-none d-md-block">
                      <h5
                        style={{
                          color: "black",
                          fontSize: "4rem",
                          fontWeight: "bold",
                        }}
                      >
                        Trading Bot for Crypto
                        <br></br>
                        Python, Node, React
                        <br></br>
                      </h5>
                      <p
                        style={{
                          color: "red",
                          fontSize: "2rem",
                          fontWeight: "bold",
                        }}
                      >
                        (Under Construction...)
                      </p>
                    </div>
                  </div>

                  <div class="carousel-item" style={{ cursor: "zoom-in" }}>
                    <a href="https://four-brick-airboat.glitch.me/">
                      <img
                        style={{ width: "1200px", height: "1200px" }}
                        src="04.png"
                        alt="fourth slide"
                        cursor="pointer"
                      />
                    </a>

                    <div class="carousel-caption d-none d-md-block">
                      <h5
                        style={{
                          color: "black",
                          fontSize: "4rem",
                          fontWeight: "bold",
                        }}
                      >
                        Some More Stuff
                        <br></br>
                      </h5>
                    </div>
                  </div>
                </div>
                <a
                  class="carousel-control-prev"
                  href="#carouselExampleIndicators"
                  role="button"
                  data-slide="prev"
                  onClick={() => props.onChange(randomColor())}
                >
                  <span
                    class="carousel-control-prev-icon"
                    style={{
                      width: "200px",
                      height: "200px",
                      backgroundColor: "black",
                    }}
                    aria-hidden="true"
                  ></span>
                  <span class="sr-only">Previous</span>
                </a>
                <a
                  class="carousel-control-next"
                  href="#carouselExampleIndicators"
                  role="button"
                  data-slide="next"
                  onClick={() => props.onChange(randomColor())}
                >
                  <span
                    style={{
                      width: "200px",
                      height: "200px",
                      backgroundColor: "black",
                    }}
                    class="carousel-control-next-icon"
                    aria-hidden="true"
                  ></span>
                  <span class="sr-only" style={{ color: "red" }}>
                    Next
                  </span>
                </a>
              </div>
            </Html>
          ) : null}
          {/*<videoTexture
          attach="map"
          args={[video]}
          encoding={THREE.sRGBEncoding}
        />*/}
        </meshBasicMaterial>
      </mesh>
    </>
  );
}

function ButtonLink({ ...props }) {
  const mesh = useRef();
  // Set up state for the hovered and active state
  const [hovered, setHover] = useState(false);
  const [active, setActive] = useState(false);
  // Subscribe this component to the render-loop, rotate the mesh every frame
  const url = "https://www.linkedin.com/in/jacob-yanov/";
  //function that navigates to another url when clicked
  function handleClick() {
    window.open(url, "_blank");
    setActive(!active);
  }
  useCursor(hovered);

  return (
    <mesh
      ref={mesh}
      {...props}
      onClick={(event) => handleClick()}
      onPointerOver={(event) => setHover(true)}
      onPointerOut={(event) => setHover(false)}
      position={[0, active ? -0.03 : 0, 0]}
    >
      <cylinderBufferGeometry args={[0.14, 0.14, 0.14, 32]} />
      <meshPhysicalMaterial
        envMapIntensity={0.4}
        clearcoat={0.8}
        clearcoatRoughness={0}
        roughness={1}
        metalness={0}
        color={hovered ? "orange" : "black"}
      />
      <Text
        anchorX="center"
        anchorY="middle"
        position={[0, 0.09, 0]}
        rotation={[-Math.PI / 4, 0, 0]}
        fontSize={0.045}
        color={hovered ? "white" : "white"}
        style={{ cursor: "pointer" }}
        fontWeight={"bold"}
      >
        Contact Me!
      </Text>
    </mesh>
  );
}

function App() {
  const [clicked, setClicked] = useState(false);
  const [ready, setReady] = useState(false);
  const store = { clicked, setClicked, ready, setReady };
  const [color, setColor] = useState("#0c8cbf");
  const [size, setGrowButton] = useState(0.2);
  const [hovered, setActive] = useState(false);

  useCursor(hovered);

  return (
    <>
      <Canvas
        concurrent
        mode="concurrent"
        gl={{ alpha: false }}
        pixelRatio={[2, 2]}
        performance={{
          current: 1,
          min: 0.1,
          max: 1,
          debounce: 200,
        }}
        camera={{ position: [0, 3, 100], fov: 15 }}
      >
        <color attach="background" args={["black"]} />
        <fog attach="fog" args={["black", 15, 20]} />
        <Suspense fallback={null}>
          <group position={[0, -1, 0]}>
            <Carla
              rotation={[0, Math.PI - 0.4, 0]}
              position={[-0.8, 0, 0.9]}
              scale={[0.0056, 0.0056, 0.0056]}
            />

            <VideoText
              ready={clicked}
              {...store}
              position={[0, 1.3, -2]}
              onChange={(c) => setColor(c)}
            />
            <ButtonLink
              style={{ cursor: "pointer" }}
              onHover={(c) => setColor(c)}
              position={[0, 0.01, 0.8]}
            />
            <Ground />
          </group>
          <ambientLight intensity={0.5} />
          <spotLight position={[0, 10, 0]} intensity={0.8} color={color} />
          <directionalLight
            position={[0, 0, 2]}
            intensity={0.7}
            color={color}
          />
          <Intro start={ready && clicked} set={setReady} />
        </Suspense>
      </Canvas>
      <Loadera {...store} />
    </>
  );
}

function Loadera({ ready, clicked, setClicked }) {
  const { active, progress } = useProgress();

  const transition = useTransition(active, {
    from: { opacity: 1, progress: 0 },
    leave: { opacity: 0 },
    update: { progress },
    onRest: () => {
      setClicked(true);
    },
  });
  return transition(
    ({ progress, opacity }, active) =>
      active && (
        <a.div className="loading" style={{ opacity }}>
          <div className="loading-bar-container">
            <a.div className="loading-bar" style={{ width: progress }}>
              <a.span className="loading-data">
                {progress.to((p) => `${p.toFixed(2)}%`)}
              </a.span>
            </a.div>
          </div>
        </a.div>
      )
  );
}

function Intro({ start, set }) {
  const [vec] = useState(() => new THREE.Vector3());
  useEffect(() => setTimeout(() => set(true), 500), []);
  return useFrame((state) => {
    if (start) {
      state.camera.position.lerp(
        vec.set(state.mouse.x * 2, 3 + state.mouse.y * 2, 14),
        0.05
      );
      state.camera.lookAt(0, 0, 0);
    }
  });
}

export default App;
